// extracted by mini-css-extract-plugin
export var icon = "location-module--icon---zn0Z";
export var location = "location-module--location--E7qTB";
export var section = "location-module--section--a1+2R";